export { AmpStyle } from "./amp-style";
